module.exports = __webpack_public_path__ + "img/9788925557601.120a20b9.jpg";